module.exports = __webpack_public_path__ + "img/4_92.1d5a8a34.png";